
import employees from '../store/modules/employees';
import CrossSalonDialog from './CrossSalonDialog.vue';
export default {
  components: { CrossSalonDialog },
  props: {
    departmentList: {
      type: Array,
      required: false,
    },
    urlDepartments: {
      type: Array,
      required: false,
    },
    employeeList: {
      type: Array,
      required: false
    },
    urlEmployees: {
      type: Array,
      required: false
    },
    isMobile: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  data() {
    return {
      panel: [0, 1, 2],
    };
  },
  computed: {
    selectedBookingSalon() {
      return this.$store.getters['cart/getSelectedSalon']
    },
    isSingleSite() {
      return this.$store.getters['salon/getIsSingleSite']
    },
    isLoadingEmployees() {
      return this.$store.getters['employees/getIsLoadingEmployees']
    }
  },
  methods: {
    async selectDepartment(siteId, action = 'switched-in-filter') {
      if (siteId && siteId !== 0) {
        let currentSiteId = this.selectedBookingSalon
        this.handleUrl(siteId)
        this.$store.commit('cart/setPreviousSelectedSalon')
        /**
         * If user clicks keep salon choice in the cross site dialog, then we set the selected salon even if
         * the siteId is equal to the currently selected one.
         */
        if (action === 'keep-salon-choice') {
          this.$store.commit("cart/setSelectedSalon", siteId)

          /**
           * If the user deselects in the filter (no salon selected in the filter)
           */
        } else if (action === 'none-selected') {
            const cart = this.$store.getters['cart/getCart'];
            this.$store.commit("cart/setSelectedSalon", cart && cart.siteId ? cart.siteId : null)
          /**
           * Normal switch between salons in the filter
           */
        } else {
          this.$store.commit("cart/setSelectedSalon", currentSiteId === siteId ? null : siteId)
        }
      }
    },
    async handleUrl(siteId, clearEmployees = true, isMounting = false) {
      let urlDepartments = this.urlDepartments.slice();
      if (urlDepartments.includes(siteId) && !isMounting) {
        urlDepartments = []
      } else {
        urlDepartments = [siteId]
      }
      if (!this.isMobile) {
        this.$router.push({
          query: {
            ...JSON.parse(JSON.stringify(this.$route.query)),
            department: urlDepartments,
            employees: clearEmployees ? undefined : this.urlEmployees.slice(),
          },
        });
      } else {
        this.$emit("setDeptFilter", urlDepartments);
      }
    },
    selectEmployee(base64EmployeeId) {
      let urlEmployees = this.urlEmployees.slice();
      if (!this.urlEmployees.includes(base64EmployeeId)) {
        urlEmployees.push(base64EmployeeId);
      } else {
        if (urlEmployees.length && urlEmployees != null && urlEmployees != undefined) {
          let index = urlEmployees.indexOf(base64EmployeeId);
          urlEmployees.splice(index, 1);
        }
      }
      if (!this.isMobile) {
        this.$router.push({
          query: {
            ...JSON.parse(JSON.stringify(this.$route.query)),
            employees: urlEmployees,
          },
        });
      } else {
        this.$emit("setEmpFilter", urlEmployees);
      }
    },
  },
  watch: {
    async selectedBookingSalon() {
      let alreadyHandled = this.$store.getters['cart/getPreviousSelectedSalon'] !== null && this.$store.getters['cart/getPreviousSelectedSalon'] !== 0
      if (this.selectedBookingSalon && !alreadyHandled) {
        this.handleUrl(this.selectedBookingSalon)
      }
    }
  },
  async mounted() {
    let alreadyHandled = this.$store.getters['cart/getPreviousSelectedSalon'] !== 0
    if (this.selectedBookingSalon && !alreadyHandled) {
      this.handleUrl(this.selectedBookingSalon, false, true)
    }
    await this.$store.dispatch("employees/getSiteEmployees", this.selectedBookingSalon);
  },
  beforeMount() {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", this.onScroll);
    }
  },
};
